import React, { useEffect, useState } from 'react';

import { NavbarBrand } from 'reactstrap';
import { IoLogoTwitter, IoMdWallet } from 'react-icons/io';

import { ExternalRoutes, SiteRoutes } from '../../resources/enums/SiteRoutes';
import {
	NavbarIconDiv,
	WalletIconDiv,
} from '../../resources/styles/Sidebar.style';
import { TEXT_WHITE, TEXT_PURPLE } from '../../resources/constants/colors';
import {
	CustomNavLink,
	CustomNavItem,
	ExternalNavLink,
	NavbarContainer,
} from '../../resources/styles/Router.styles';
import { useLocation } from 'react-router-dom';
import CustomButton from '../../resources/styles/CustomButton.styles';
import ReactTooltip from 'react-tooltip';
import { useDispatch, useSelector } from 'react-redux';
import RootReducerStateInterface from '../../resources/interfaces/ReducerInterfaces/RootReducerStateInterface';
import { countActiveReservations } from '../../helpers/store';
import { NavBar, NavMenu } from '../../resources/styles/NavBar.styles';
import { Collections } from '../../resources/enums/Collections';
import { setFilterByWallet } from '../../redux/actions/filter';
interface PropsInterface {
	handleSidebar: () => void;
}

const Navigationbar = (props: PropsInterface): JSX.Element => {
	const { handleSidebar } = props;
	const isAuthenticated = useSelector(
		(state: RootReducerStateInterface) => state.auth.isAuthenticated
	);
	const { reservedItems, purchasedItems } = useSelector(
		(state: RootReducerStateInterface) => state.store
	);
	const address = useSelector(
		(state: RootReducerStateInterface) => state.wallet.address
	);
	const dispatch = useDispatch();
	const location = useLocation();
	const [numberOfReservations, setNumberOfReservations] = useState(0);

	useEffect(() => {
		setNumberOfReservations(
			countActiveReservations(reservedItems, purchasedItems)
		);
	}, [reservedItems, purchasedItems]);

	const AuthorizedNavbarView = () => {
		return (
			<>
				<CustomNavItem onClick={closeCollapse}>
					<div className="icon-wrapper">
						<NavbarIconDiv onClick={handleSidebar}>
							<WalletIconDiv>
								<IoMdWallet size={22} id="wallet" />
								{!!numberOfReservations && <div id="notification"></div>}
							</WalletIconDiv>
							{isNavbarTogglerOpen && (
								<span className="wallet-text">View wallet</span>
							)}
						</NavbarIconDiv>
						<CustomNavLink
							to={SiteRoutes.profile}
							className="nav-icon"
							onClick={() => dispatch(setFilterByWallet(address))}
						>
							{profileIcon}
						</CustomNavLink>
						{/* <NavIcon className="nav-icon">{notificationIcon}</NavIcon> */}
					</div>
				</CustomNavItem>
			</>
		);
	};

	const WalletNotConnectedView = () => {
		return (
			<CustomNavLink
				to={SiteRoutes.connectWallet}
				style={{
					color: `${TEXT_WHITE}`,
				}}
			>
				{
					<div>
						{isNavbarTogglerOpen || (
							<CustomButton
								width="150px"
								backgroundColorHover={TEXT_PURPLE}
								backgroundColor={TEXT_PURPLE}
								onClick={closeCollapse}
							>
								Connect Wallet{' '}
							</CustomButton>
						)}
						{isNavbarTogglerOpen && <IoMdWallet size={22} id="wallet" />}
						{isNavbarTogglerOpen && 'Connect wallet'}
					</div>
				}
			</CustomNavLink>
		);
	};

	const [isNavbarTogglerOpen, setIsNavbarTogglerOpen] = useState(false);
	const closeCollapse = () => setIsNavbarTogglerOpen(false);
	const toggleCollapse = () => setIsNavbarTogglerOpen(!isNavbarTogglerOpen);

	return (
		<NavbarContainer route={location.pathname} id="navbar-container">
			<NavBar>
				<div className="nav-elements">
					<NavbarBrand href={ExternalRoutes.skvllpvnkzWebsite}>
						<div className="desktop-logo">{skvllpvnkzLogoSVG}</div>
						<div className="mobile-logo">{skvllpvnkzLogoSmallSVG}</div>
					</NavbarBrand>
					<div className="hamburger-section">
						<NavMenu isOpen={isNavbarTogglerOpen}>
							<ul className="nav-list">
								<div className="close" onClick={closeCollapse}>
									{skvllpvnkzLogoSmallSVG}
									{closeIconSVG}
								</div>
								<div className="nav-content-wrapper">
									<div className="nav-icons">
										<CustomNavItem onClick={closeCollapse}>
											<NavbarIconDiv>
												<ExternalNavLink
													href={ExternalRoutes.skvllpvnkzOS}
													target="_blank"
													rel="noreferrer"
												>
													{openseaLogoSVG}
												</ExternalNavLink>
											</NavbarIconDiv>
										</CustomNavItem>
										<CustomNavItem onClick={closeCollapse}>
											<NavbarIconDiv>
												<ExternalNavLink
													href={ExternalRoutes.skvllpvnkzTwitter}
													target="_blank"
													rel="noreferrer"
												>
													<IoLogoTwitter size={22} />
												</ExternalNavLink>
											</NavbarIconDiv>
										</CustomNavItem>
										<CustomNavItem onClick={closeCollapse}>
											<NavbarIconDiv>
												<ExternalNavLink
													href={ExternalRoutes.skvllpvnkzDiscord}
													target="_blank"
													rel="noreferrer"
												>
													{discordLogoSVG}
												</ExternalNavLink>
											</NavbarIconDiv>
										</CustomNavItem>
										<CustomNavItem onClick={closeCollapse}>
											<NavbarIconDiv>
												<ExternalNavLink
													href={ExternalRoutes.hideoutPaper}
													target="_blank"
													rel="noreferrer"
													data-tip="Hideout paper & roadmap"
													data-delay-show="100"
												>
													<ReactTooltip />
													{skvllpvnkzLogoSmallSVG}
												</ExternalNavLink>
											</NavbarIconDiv>
										</CustomNavItem>
									</div>
									<div className="nav-page-link">
										<CustomNavItem onClick={closeCollapse}>
											<CustomNavLink
												onClick={() => dispatch(setFilterByWallet(''))}
												to={`${SiteRoutes.discover
													}/${Collections.skvllpvnkz_hideout.replace('_', '-')}`}
											>
												Discover
											</CustomNavLink>
										</CustomNavItem>
										<CustomNavItem onClick={closeCollapse}>
											<CustomNavLink to={SiteRoutes.hideout}>
												Hideout
											</CustomNavLink>
										</CustomNavItem>
										<CustomNavItem onClick={closeCollapse}>
											<CustomNavLink to={SiteRoutes.breeding}>
												Breeding
											</CustomNavLink>
										</CustomNavItem>
										<CustomNavItem onClick={closeCollapse}>
											<CustomNavLink to={SiteRoutes.daycare}>
												Daycare
											</CustomNavLink>
										</CustomNavItem>
										<CustomNavItem onClick={closeCollapse}>
											<CustomNavLink to={SiteRoutes.store}>Store</CustomNavLink>
										</CustomNavItem>
										<CustomNavItem onClick={closeCollapse}>
											<CustomNavLink to={SiteRoutes.raffle}>
												Animus Beacon
											</CustomNavLink>
										</CustomNavItem>
									</div>
									<div className="nav-wallet-auth">
										{isAuthenticated ? (
											<AuthorizedNavbarView />
										) : (
											<WalletNotConnectedView />
										)}
									</div>
								</div>
							</ul>
						</NavMenu>
						{isAuthenticated ? (
							<AuthorizedNavbarView />
						) : (
							<WalletNotConnectedView />
						)}

						<div className="hamburger" onClick={toggleCollapse}>
							{hamburgerLogoSVG}
						</div>
					</div>
				</div>
			</NavBar>
		</NavbarContainer>
	);
};

export default Navigationbar;

const skvllpvnkzLogoSmallSVG = (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill="currentColor"
			clip="evenodd"
			d="M10.0806 21.2719C10.2591 19.9876 11.3326 18.3761 11.7591 17.7662V17.7637C11.8756 17.5951 11.9425 17.3943 11.95 17.1786L12.1681 10.4175C12.1731 10.2637 12.126 10.1175 12.0392 10.0034C11.5161 9.32656 10.9855 8.65218 10.4599 7.98525C10.264 7.73979 10.1723 7.50178 10.1971 7.06046C10.2244 6.5646 10.3111 3.97619 10.4128 0.889439L10.4227 0.624152C10.4351 0.217544 10.1053 -0.0799741 9.7508 0.0191987C9.09626 0.205148 8.36983 0.477872 7.61859 0.889439C6.5748 1.45224 5.47646 2.27538 4.45498 3.47041C0.862449 7.66046 0.998811 11.8902 0.998811 11.8902C0.998811 11.8902 1.02361 12.5249 1.06824 13.2216C1.09799 13.715 1.13766 14.2406 1.1922 14.5901C1.21699 14.7463 1.24675 14.9819 1.2765 15.2695C1.41534 16.5463 1.59881 18.8422 1.49467 19.5959C1.36327 20.5207 -0.300349 22.8289 2.05996 24.2149C4.42771 25.6008 4.53184 25.3157 5.12936 24.6066C5.72439 23.8926 6.91695 23.2554 6.77067 24.7826C6.66158 25.9033 5.78142 28.0628 7.86404 29.1561C8.56073 29.5231 9.58965 29.771 11.0896 29.8181C11.3301 29.8256 11.5458 29.6099 11.5533 29.3347L11.5582 29.1537L11.7838 22.405C11.7417 22.3802 11.6971 22.3678 11.645 22.3678C9.93179 22.3281 10.0359 21.4975 10.0657 21.3413C10.0706 21.324 10.0756 21.2992 10.0806 21.2719ZM10.1772 15.1976C10.088 15.2149 10.0012 15.2422 9.92436 15.272C9.61196 15.3934 9.38139 15.6141 9.2004 15.9364C8.75412 16.7645 7.97313 16.9405 7.15248 17.0174C6.93926 17.0372 6.75331 17.062 6.54257 17.062C6.22521 17.0348 5.87067 17.0248 5.56076 16.9777C4.45002 16.7943 3.71614 16.2091 3.43598 15.272C3.34425 14.9868 3.3021 14.667 3.29962 14.3174C3.29714 13.953 3.32441 13.586 3.36904 13.224C3.40127 12.9216 3.4459 12.6191 3.49549 12.3241C3.61945 11.6051 3.98391 11.3596 4.69796 11.4365C5.83596 11.5629 6.88719 11.9621 7.93842 12.3736C8.5285 12.6042 9.08883 12.8819 9.61692 13.2216C9.907 13.4075 10.1872 13.6158 10.4574 13.8389C10.5814 13.9406 10.7053 14.0571 10.7996 14.191C11.0252 14.5158 10.9161 14.8901 10.5516 15.0637C10.4326 15.1257 10.3037 15.1703 10.1772 15.1976Z"
		/>
		<path
			fill="currentColor"
			clip="evenodd"
			d="M23.7565 23.5107C23.5483 23.7636 23.2607 24.0016 22.8789 24.2173C20.4243 25.6008 20.3376 25.3182 19.7896 24.6091C19.2367 23.8975 18.0839 23.2579 18.131 24.7851C18.1781 26.2777 19.5987 29.6322 13.5988 29.8231C13.3558 29.8305 13.1599 29.6198 13.1649 29.3495L13.274 22.4124C13.3161 22.3851 13.3632 22.3727 13.4128 22.3727C15.131 22.3331 15.0789 21.505 15.0591 21.3488C15.0541 21.3265 15.0516 21.2992 15.0492 21.2719C14.9525 19.9901 13.9806 18.3761 13.5963 17.7662V17.7637C13.4897 17.5951 13.4351 17.3893 13.4426 17.181L13.6583 10.41C13.6632 10.2563 13.7178 10.11 13.8145 9.99598C14.3847 9.31665 14.9525 8.64475 15.5252 7.98029C15.7335 7.73732 15.8426 7.4993 15.8475 7.06047C15.8549 6.54973 15.9368 3.82744 16.0384 0.629115C16.0508 0.222507 16.4004 -0.0725323 16.7475 0.0266405C17.531 0.252258 18.4186 0.60928 19.3161 1.18696C19.5566 1.3382 19.6855 1.64316 19.6409 1.95555L18.8996 7.04807L18.8723 7.2365C18.7979 7.75715 19.1921 8.18608 19.6533 8.09186L22.6012 7.48195C23.0698 7.38526 23.4665 7.82905 23.3797 8.34971L23.3177 8.73648L22.9061 11.0051C22.8417 11.4018 22.5268 11.6968 22.1698 11.6968H16.8392C16.4103 11.6968 16.0012 11.9522 15.7756 12.3687C15.4012 13.0455 15.0963 13.6034 14.8459 14.067C14.2955 15.0761 14.9673 16.6182 16.088 16.6182H21.2028C21.6442 16.6182 21.9689 17.0546 21.8896 17.5455L21.6937 18.7653C21.6615 18.9637 21.6987 19.1695 21.8003 19.3356L23.8284 22.5413C24.0094 22.8339 23.9797 23.238 23.7565 23.5107Z"
		/>
		<path
			fill="currentColor"
			clip="evenodd"
			d="M22.7747 13.4297H17.4243C17.2012 13.4297 17.0153 13.6206 17.0078 13.8537L16.983 14.6371C16.9756 14.8727 17.1491 15.0611 17.3723 15.0611H22.7251C22.9483 15.0611 23.1342 14.8702 23.1392 14.6371L23.1615 13.8537C23.1714 13.6206 22.9978 13.4297 22.7747 13.4297Z"
		/>
	</svg>
);

const skvllpvnkzLogoSVG = (
	<svg
		width="196"
		height="38"
		viewBox="0 0 196 38"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M5.17435 0.00195312L4.11072 5.99446H10.4677L10.4702 5.98951H20.0428L21.1015 0.00195312H5.17435Z"
			fill="white"
		/>
		<path
			d="M10.2297 7.33838H3.87269L1.99585 17.9275H11.5685L10.552 23.8754H1.05867L0 29.8233H15.9271L19.066 11.94H9.40901L10.2297 7.33838Z"
			fill="white"
		/>
		<path
			d="M22.3957 15.3911L19.8395 29.8232H26.2758L28.8344 15.3911H22.3957Z"
			fill="white"
		/>
		<path
			d="M41.0624 0.00195312H34.6658L30.1039 8.06717L31.5295 0.00195312H23.4643L22.4453 5.90769H24.0742L22.6411 13.9977L29.0849 13.9754H32.3452L28.108 37.8066H34.5047L39.8005 7.94569H36.4608L41.0624 0.00195312Z"
			fill="white"
		/>
		<path
			d="M67.5961 29.8232L71.8333 5.91017H70.1622L71.1812 0.00195312H79.2886L75.0936 23.8332H83.1191L82.0605 29.8207H67.5961V29.8232Z"
			fill="white"
		/>
		<path
			d="M84.5423 29.8232L88.7794 5.91017H87.1084L88.1274 0.00195312H96.2347L92.0397 23.8332H100.065L99.0066 29.8207H84.5423V29.8232Z"
			fill="white"
		/>
		<path
			d="M105.217 7.50928L101.285 29.8231H107.764L111.686 7.50928H105.217Z"
			fill="white"
		/>
		<path
			d="M106.541 0.00195312L105.495 5.93L112.38 5.94984H115.055L113.302 15.9316H111.755L110.697 21.8795H118.601L122.468 0.00195312H106.541Z"
			fill="white"
		/>
		<path
			d="M124.792 0.00195312H131.106L131.067 14.7911L135.914 0.00195312H140.885L130.782 29.8232H124.467L124.792 0.00195312Z"
			fill="white"
		/>
		<path
			d="M143.002 0.00195312H149.275L150.904 9.90187L152.657 0.00195312H159.053L153.797 29.8232H147.4L148.174 25.3827L146.627 15.8498L144.182 29.8232H137.746L143.002 0.00195312Z"
			fill="white"
		/>
		<path
			d="M160.352 15.1309L157.749 29.8233H164.185L166.791 15.1309H160.352Z"
			fill="white"
		/>
		<path
			d="M178.972 0.00195312H172.578L168.013 8.06717L169.442 0.00195312H161.374L160.355 5.90769H161.986L160.553 13.9927L166.997 13.9754H170.255L166.018 37.8066H172.414L177.71 7.94569H174.37L178.972 0.00195312Z"
			fill="white"
		/>
		<path
			d="M181.417 0.00195312H196L194.941 5.98951L183.698 23.8728H191.723L190.665 29.8207H176.081L177.14 23.8728L188.465 5.98951H180.358L181.417 0.00195312Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M52.0806 21.2719C52.2591 19.9876 53.3326 18.3761 53.7591 17.7662V17.7637C53.8756 17.5951 53.9425 17.3943 53.95 17.1786L54.1681 10.4175C54.1731 10.2637 54.126 10.1175 54.0392 10.0034C53.5161 9.32656 52.9855 8.65218 52.4599 7.98525C52.264 7.73979 52.1723 7.50178 52.1971 7.06046C52.2244 6.5646 52.3111 3.97619 52.4128 0.889439L52.4227 0.624152C52.4351 0.217544 52.1053 -0.0799741 51.7508 0.0191987C51.0963 0.205148 50.3698 0.477872 49.6186 0.889439C48.5748 1.45224 47.4765 2.27538 46.455 3.47041C42.8624 7.66046 42.9988 11.8902 42.9988 11.8902C42.9988 11.8902 43.0236 12.5249 43.0682 13.2216C43.098 13.715 43.1377 14.2406 43.1922 14.5902C43.217 14.7463 43.2467 14.9819 43.2765 15.2695C43.4153 16.5463 43.5988 18.8422 43.4947 19.5959C43.3633 20.5207 41.6997 22.8289 44.06 24.2149C46.4277 25.6008 46.5318 25.3157 47.1294 24.6066C47.7244 23.8926 48.9169 23.2554 48.7707 24.7826C48.6616 25.9033 47.7814 28.0628 49.864 29.1561C50.5607 29.5231 51.5897 29.771 53.0896 29.8181C53.3301 29.8256 53.5458 29.6099 53.5533 29.3347L53.5582 29.1537L53.7838 22.405C53.7417 22.3802 53.6971 22.3678 53.645 22.3678C51.9318 22.3281 52.0359 21.4975 52.0657 21.3413C52.0706 21.324 52.0756 21.2992 52.0806 21.2719ZM52.1772 15.1976C52.088 15.2149 52.0012 15.2422 51.9244 15.272C51.612 15.3934 51.3814 15.6141 51.2004 15.9364C50.7541 16.7645 49.9731 16.9405 49.1525 17.0174C48.9393 17.0372 48.7533 17.062 48.5426 17.062C48.2252 17.0348 47.8707 17.0248 47.5608 16.9777C46.45 16.7943 45.7161 16.2091 45.436 15.272C45.3442 14.9868 45.3021 14.667 45.2996 14.3174C45.2971 13.953 45.3244 13.586 45.369 13.224C45.4013 12.9216 45.4459 12.6191 45.4955 12.3241C45.6195 11.6051 45.9839 11.3596 46.698 11.4365C47.836 11.5629 48.8872 11.9621 49.9384 12.3736C50.5285 12.6042 51.0888 12.8819 51.6169 13.2216C51.907 13.4075 52.1872 13.6158 52.4574 13.8389C52.5814 13.9406 52.7053 14.0571 52.7996 14.191C53.0252 14.5158 52.9161 14.8901 52.5516 15.0637C52.4326 15.1257 52.3037 15.1703 52.1772 15.1976Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M65.7565 23.5107C65.5482 23.7636 65.2606 24.0016 64.8788 24.2173C62.4243 25.6008 62.3375 25.3182 61.7896 24.6091C61.2367 23.8975 60.0838 23.2579 60.1309 24.7851C60.178 26.2777 61.5987 29.6322 55.5987 29.8231C55.3557 29.8305 55.1599 29.6198 55.1648 29.3495L55.2739 22.4124C55.3161 22.3851 55.3632 22.3727 55.4128 22.3727C57.1309 22.3331 57.0789 21.505 57.059 21.3488C57.0541 21.3265 57.0516 21.2992 57.0491 21.2719C56.9524 19.9901 55.9805 18.3761 55.5962 17.7662V17.7637C55.4896 17.5951 55.4351 17.3893 55.4425 17.181L55.6582 10.41C55.6632 10.2563 55.7177 10.11 55.8144 9.99598C56.3846 9.31665 56.9524 8.64475 57.5251 7.98029C57.7334 7.73732 57.8425 7.4993 57.8475 7.06047C57.8549 6.54973 57.9367 3.82743 58.0384 0.629115C58.0508 0.222507 58.4003 -0.0725323 58.7474 0.0266405C59.5309 0.252258 60.4185 0.60928 61.316 1.18696C61.5565 1.3382 61.6854 1.64316 61.6408 1.95555L60.8995 7.04807L60.8722 7.2365C60.7978 7.75715 61.192 8.18608 61.6532 8.09186L64.6011 7.48195C65.0697 7.38526 65.4664 7.82905 65.3796 8.34971L65.3176 8.73648L64.9061 11.0051C64.8416 11.4018 64.5267 11.6968 64.1697 11.6968H58.8392C58.4103 11.6968 58.0012 11.9522 57.7755 12.3687C57.4012 13.0455 57.0962 13.6034 56.8458 14.067C56.2954 15.0761 56.9673 16.6182 58.0879 16.6182H63.2028C63.6441 16.6182 63.9689 17.0546 63.8895 17.5455L63.6937 18.7653C63.6614 18.9637 63.6986 19.1695 63.8003 19.3356L65.8284 22.5413C66.0094 22.8339 65.9796 23.238 65.7565 23.5107Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M64.7746 13.4297H59.4243C59.2011 13.4297 59.0152 13.6206 59.0078 13.8537L58.983 14.6371C58.9755 14.8727 59.1491 15.0611 59.3722 15.0611H64.7251C64.9482 15.0611 65.1341 14.8702 65.1391 14.6371L65.1614 13.8537C65.1713 13.6206 64.9978 13.4297 64.7746 13.4297Z"
			fill="#1CA595"
		/>
	</svg>
);

const discordLogoSVG = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		role="img"
		width="21px"
		height="21px"
		preserveAspectRatio="xMidYMid meet"
		viewBox="0 0 24 24"
	>
		<path
			fill="currentColor"
			d="m22 24l-5.25-5l.63 2H4.5A2.5 2.5 0 0 1 2 18.5v-15A2.5 2.5 0 0 1 4.5 1h15A2.5 2.5 0 0 1 22 3.5V24M12 6.8c-2.68 0-4.56 1.15-4.56 1.15c1.03-.92 2.83-1.45 2.83-1.45l-.17-.17c-1.69.03-3.22 1.2-3.22 1.2c-1.72 3.59-1.61 6.69-1.61 6.69c1.4 1.81 3.48 1.68 3.48 1.68l.71-.9c-1.25-.27-2.04-1.38-2.04-1.38S9.3 14.9 12 14.9s4.58-1.28 4.58-1.28s-.79 1.11-2.04 1.38l.71.9s2.08.13 3.48-1.68c0 0 .11-3.1-1.61-6.69c0 0-1.53-1.17-3.22-1.2l-.17.17s1.8.53 2.83 1.45c0 0-1.88-1.15-4.56-1.15m-2.07 3.79c.65 0 1.18.57 1.17 1.27c0 .69-.52 1.27-1.17 1.27c-.64 0-1.16-.58-1.16-1.27c0-.7.51-1.27 1.16-1.27m4.17 0c.65 0 1.17.57 1.17 1.27c0 .69-.52 1.27-1.17 1.27c-.64 0-1.16-.58-1.16-1.27c0-.7.51-1.27 1.16-1.27Z"
		/>
	</svg>
);

const openseaLogoSVG = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		role="img"
		width="21px"
		height="21px"
		preserveAspectRatio="xMidYMid meet"
		viewBox="0 0 24 24"
	>
		<path
			fill="currentColor"
			d="M12 0C5.374 0 0 5.374 0 12s5.374 12 12 12s12-5.374 12-12S18.629 0 12 0ZM5.92 12.403l.051-.081l3.123-4.884a.107.107 0 0 1 .187.014c.52 1.169.972 2.623.76 3.528c-.088.372-.335.876-.614 1.342a2.405 2.405 0 0 1-.117.199a.106.106 0 0 1-.09.045H6.013a.106.106 0 0 1-.091-.163zm13.914 1.68a.109.109 0 0 1-.065.101c-.243.103-1.07.485-1.414.962c-.878 1.222-1.548 2.97-3.048 2.97H9.053a4.019 4.019 0 0 1-4.013-4.028v-.072c0-.058.048-.106.108-.106h3.485c.07 0 .12.063.115.132c-.026.226.017.459.125.67c.206.42.636.682 1.099.682h1.726v-1.347H9.99a.11.11 0 0 1-.089-.173l.063-.09c.16-.231.391-.586.621-.992c.156-.274.308-.566.43-.86c.024-.052.043-.107.065-.16c.033-.094.067-.182.091-.269a4.57 4.57 0 0 0 .065-.223c.057-.25.081-.514.081-.787c0-.108-.004-.221-.014-.327c-.005-.117-.02-.235-.034-.352a3.415 3.415 0 0 0-.048-.312a6.494 6.494 0 0 0-.098-.468l-.014-.06c-.03-.108-.056-.21-.09-.317a11.824 11.824 0 0 0-.328-.972a5.212 5.212 0 0 0-.142-.355c-.072-.178-.146-.339-.213-.49a3.564 3.564 0 0 1-.094-.197a4.658 4.658 0 0 0-.103-.213c-.024-.053-.053-.104-.072-.152l-.211-.388c-.029-.053.019-.118.077-.101l1.32.357h.01l.173.05l.192.054l.07.019v-.783c0-.379.302-.686.679-.686a.66.66 0 0 1 .477.202a.69.69 0 0 1 .2.484V6.65l.141.039c.01.005.022.01.031.017c.034.024.084.062.147.11c.05.038.103.086.165.137a10.351 10.351 0 0 1 .574.504c.214.199.454.432.684.691c.065.074.127.146.192.226c.062.079.132.156.19.232c.079.104.16.212.235.324c.033.053.074.108.105.161c.096.142.178.288.257.435c.034.067.067.141.096.213c.089.197.159.396.202.598a.65.65 0 0 1 .029.132v.01c.014.057.019.12.024.184a2.057 2.057 0 0 1-.106.874c-.031.084-.06.17-.098.254c-.075.17-.161.343-.264.502c-.034.06-.075.122-.113.182c-.043.063-.089.123-.127.18a3.89 3.89 0 0 1-.173.221c-.053.072-.106.144-.166.209c-.081.098-.16.19-.245.278c-.048.058-.1.118-.156.17c-.052.06-.108.113-.156.161c-.084.084-.15.147-.208.202l-.137.122a.102.102 0 0 1-.072.03h-1.051v1.346h1.322c.295 0 .576-.104.804-.298c.077-.067.415-.36.816-.802a.094.094 0 0 1 .05-.03l3.65-1.057a.108.108 0 0 1 .138.103z"
		/>
	</svg>
);

const hamburgerLogoSVG = (
	<svg
		width="18"
		height="12"
		viewBox="0 0 18 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M0 12H18V10H0V12ZM0 7H18V5H0V7ZM0 0V2H18V0H0Z" fill="white" />
	</svg>
);

const closeIconSVG = (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
			fill="white"
		/>
	</svg>
);

const profileIcon = (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M9 9C11.4862 9 13.5 6.98625 13.5 4.5C13.5 2.01375 11.4862 0 9 0C6.51375 0 4.5 2.01375 4.5 4.5C4.5 6.98625 6.51375 9 9 9ZM9 11.25C5.99625 11.25 0 12.7575 0 15.75V18H18V15.75C18 12.7575 12.0037 11.25 9 11.25Z"
			fill="currentColor"
		/>
	</svg>
);

// const notificationIcon = (
// 	<svg
// 		width="16"
// 		height="20"
// 		viewBox="0 0 16 20"
// 		fill="none"
// 		xmlns="http://www.w3.org/2000/svg"
// 	>
// 		<path
// 			d="M8 19.75C9.1 19.75 10 18.85 10 17.75H6C6 18.85 6.9 19.75 8 19.75ZM14 13.75V8.75C14 5.68 12.37 3.11 9.5 2.43V1.75C9.5 0.92 8.83 0.25 8 0.25C7.17 0.25 6.5 0.92 6.5 1.75V2.43C3.64 3.11 2 5.67 2 8.75V13.75L0 15.75V16.75H16V15.75L14 13.75ZM12 14.75H4V8.75C4 6.27 5.51 4.25 8 4.25C10.49 4.25 12 6.27 12 8.75V14.75Z"
// 			fill="currentColor"
// 		/>
// 	</svg>
// );
